<template>
  <div :class="type" class="error-messages-wrapper message">
    <div v-for="(message, index) in messages" :key="index">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageBox",
  props: {
    type: {
      type: String,
      default: "success-message",
      validator: value => ["success-message", "error-message"].includes(value)
    },
    messages: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.error-messages-wrapper.message.info-message {
  padding: 1rem 2rem;
  margin-top: -2.7rem;
  text-align: center;
  padding: 1rem;
  background-color: rgb(253, 192, 192);
  color: rgb(134, 0, 0);
}

.error-messages-wrapper.message.success-message {
  padding: 1rem 2rem;
  margin-top: -2.7rem;
  text-align: center;
  background-color: #f1f8f1;
  color: #4fb430;
}

@media only screen and (max-width: 1374px) {
  .error-messages-wrapper.message.success-message {
    margin-top: 0;
  }
  .error-messages-wrapper.message.info-message {
    margin-top: 0;
  }
}
</style>
